var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { StyledContainer, StyledRadio, StyledRadioWrapper } from './style';
var Radio = function (_a) {
    var value = _a.value, name = _a.name, fields = _a.fields, onChange = _a.onChange, props = __rest(_a, ["value", "name", "fields", "onChange"]);
    return (React.createElement(StyledRadioWrapper, __assign({}, props), fields.map(function (field, index) { return (React.createElement("div", { key: field.fieldValue },
        React.createElement(StyledContainer, { disabled: field.disabled },
            React.createElement("input", { type: "radio", checked: field.fieldValue === value, name: name, value: field.fieldValue, disabled: field.disabled, onChange: function () { return onChange(field.fieldValue); }, "data-testid": name + "-" + index }),
            React.createElement(StyledRadio, null),
            field.content))); })));
};
export default Radio;
